import CategoriesDropwdown from 'components/CategoriesDropwdown';
import WholeNumberInput from 'components/WholeNumberInput';
import React, { useState } from 'react';
import { addSubscriptionItemConfig } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddItemConfigToSubscriptionsModal = props => {
  const [slug, setSlug] = useState<string>('');
  const [maxCount, setMaxCount] = useState<string>('0');
  const [maxCost, setMaxCost] = useState<string>('0');
  const [loading, setLoading] = useState<boolean>(false);
  const {
    subscriptionId,
    toggleModal,
    onSuccess,
  } = props;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addSubscriptionItemConfig({
        id: subscriptionId,
        slug,
        maxCount,
        maxCost,
      });
      showSuccess('ItemConfig added successfully');
      toggleModal();
      await onSuccess();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  const getFooter=()=>{
    return (
      <div className={styles['modal-footer']}>
        <button
          className={styles['cancel-button']}
          type={'button'}
          disabled={loading}
          onClick={toggleModal}
        >
            Cancel
        </button>
        <button
          className={styles['submit-button']}
          type={'submit'}
          disabled={loading}
        >
            Submit
        </button>
      </div>
    );
  };

  const getHeader=()=>{
    return (
      <div className={styles['modal-header']}>
        <div>
          <div className={styles['label']}>Item Config</div>
          <div className={styles['modal-title']}>Add Item Config</div>
        </div>
        <i className={'fa fa-times'} onClick={toggleModal} />
      </div>
    );
  };

  const getBody=()=>{
    return (
      <div className={styles['modal-body']}>
        <div className={'mb-3'}>
          <div className={styles['label']}>Category</div>
          <CategoriesDropwdown
            value = {slug}
            onSelect={slug => setSlug(slug)}
            disabled={false}
            isSlug={true}
          />  
        </div>
        <div>
          <div className={styles['label']}>Max Count</div>
          <WholeNumberInput
            value={maxCount}
            onChange={setMaxCount}
            disabled={false}
          />
        </div>
        <div>
          <div className={styles['label']}>Max Cost</div>
          <WholeNumberInput
            value={maxCost}
            onChange={setMaxCost}
            disabled={false}
          />
        </div>
      </div>
    );
  };
  return (
    <form onSubmit={handleSubmit} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        {getHeader()}
        {getBody()}
        {getFooter()}
      </div>
    </form>
  );
};

export default AddItemConfigToSubscriptionsModal;